<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="160px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('ota.FirmwareUpgradeName')">
                  <el-input
                    v-model="formselect.upgradeName"
                    style="width: 100%"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                <el-button @click="getData" type="primary" size="small">{{
                  $t("button.query")
                }}</el-button>
                <el-button @click="resetKeyword" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <el-button
              v-if="hasCreateAuth"
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="showAddDialog(true)"
              style="margin-bottom: 10px"
              >{{ $t("ota.FirmwareUpgrade") }}</el-button
            >
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                ref="tableData1"
                stripe
                v-loading="loading"
                class="formSTable NoRaidoLabel"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('ota.FirmwareUpgradeName')"
                  min-width="15%"
                  prop="upgradeName"
                >
                </el-table-column>
                <!-- <el-table-column
                  :label="$t('ota.VersionNumber')"
                  prop="versionNo"
                  min-width="30%"
                >
                </el-table-column> -->
                <!-- <el-table-column
                  :label="$t('ota.deviceType')"
                  prop="deviceType"
                  min-width="30%"
                >
                </el-table-column> -->
                <el-table-column
                  :label="$t('title.creatTime')"
                  prop="creationTime"
                  min-width="15%"
                >
                  <template slot-scope="scope">
                    {{ scope.row.creationTime.replace("T", " ").substr(0, 19) }}
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('ota.upgradeStatus')"
                  prop="upgradeStatus"
                  min-width="15%"
                >
                  <template slot-scope="scope">
                    <el-tag
                      type="success"
                      v-if="scope.row.upgradeStatus == '3'"
                      >{{ $t("ota.upgradeCompleted") }}</el-tag
                    >
                    <el-tag
                      type="danger"
                      v-if="scope.row.upgradeStatus == '-1'"
                      >{{ $t("ota.upgradeFailed") }}</el-tag
                    >
                    <el-tag
                      type="warning"
                      v-if="scope.row.upgradeStatus == '2'"
                      >{{ $t("ota.upgrading") }}</el-tag
                    >
                    <el-tag
                      type="warning"
                      v-if="scope.row.upgradeStatus == '1'"
                      >{{ $t("ota.issued") }}</el-tag
                    >
                    <el-tag
                      type="warning"
                      v-if="scope.row.upgradeStatus == '0'"
                      >{{ $t("ota.notUpgraded") }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('ota.upgradeScheduledTime')"
                  prop="scheduledTime"
                  min-width="15%"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.isScheduled == false
                        ? ""
                        : scope.row.scheduledTime
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('ota.upgradePushFileTime')"
                  prop="pushFileTime"
                  min-width="15%"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.pushFileTime == null
                        ? ""
                        : scope.row.pushFileTime.replace("T", " ")
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('ota.upgradePushInstallTime')"
                  prop="pushInstallTime"
                  min-width="15%"
                  ><template slot-scope="scope">
                    {{
                      scope.row.pushInstallTime == null
                        ? ""
                        : scope.row.pushInstallTime.replace("T", " ")
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('ota.completionTime')"
                  prop="upgradeTime"
                  min-width="15%"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.upgradeTime == null
                        ? ""
                        : scope.row.upgradeTime.replace("T", " ")
                    }}
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('title.operate')"
                  width="220"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <template>
                      <el-button
                        v-if="scope.row.upgradeStatus == 0"
                        type="success"
                        icon="el-icon-finished"
                        circle
                        :title="$t('ota.batchUpgrade')"
                        size="mini"
                        @click="massUpdate(scope.row)"
                      ></el-button>
                    </template>

                    <template>
                      <el-popconfirm
                        placement="top"
                        v-if="
                          scope.row.deviceType == 'controller' &&
                          scope.row.deviceBrand == 'HC' &&
                          !scope.row.isScheduled &&
                          (scope.row.upgradeStatus == 0 ||
                            scope.row.upgradeStatus == 1)
                        "
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('ota.confirmPushFile')"
                        @confirm="pushJobFile(scope.row.id, '')"
                        :ref="`popoverPushFile-${scope.$index}`"
                      >
                        <el-button
                          type="warning"
                          icon="el-icon-s-promotion"
                          circle
                          :title="$t('ota.upgradePushFileTitle')"
                          size="mini"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>

                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('ota.confirmPushUpgradeInstall')"
                        @confirm="pushInstallCommand(scope.row.id, '')"
                        :ref="`popoverPushInstall-${scope.$index}`"
                        v-if="
                          !scope.row.isScheduled &&
                          scope.row.upgradeStatus != 3 &&
                          scope.row.upgradeStatus != -1
                        "
                      >
                        <el-button
                          type="warning"
                          icon="el-icon-s-tools"
                          circle
                          :title="$t('ota.upgradePushInstallTitle')"
                          size="mini"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>

                    <template>
                      <el-button
                        v-if="
                          scope.row.deviceType == 'controller' &&
                          scope.row.deviceBrand == 'HC' &&
                          scope.row.upgradeStatus == 1
                        "
                        type="warning"
                        icon="el-icon-timer"
                        circle
                        :title="$t('ota.RegularUpgrade')"
                        size="mini"
                        @click="TimeUpgrade(scope.row)"
                      ></el-button>
                    </template>

                    <template>
                      <el-button
                        icon="el-icon-document"
                        circle
                        :title="$t('ota.upgradeResult')"
                        size="mini"
                        @click="UpdateResult(scope.row)"
                      ></el-button>
                    </template>

                    <template>
                      <el-button
                        v-if="hasUpdateAuth && scope.row.upgradeStatus == 0"
                        type="primary"
                        icon="el-icon-edit"
                        circle
                        :title="$t('button.update')"
                        size="mini"
                        @click="edit(scope.row)"
                      ></el-button>
                    </template>

                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.delete')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="delInfo(scope.row.id)"
                        :ref="`popover-${scope.$index}`"
                        v-if="hasDeleteAuth && scope.row.upgradeStatus == 0"
                      >
                        <el-button
                          type="danger"
                          slot="reference"
                          icon="el-icon-delete"
                          :title="$t('button.delete')"
                          circle
                          size="mini"
                        >
                        </el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pagination.totalPage"
                :current-page.sync="pagination.current"
                :page-size="pagination.pageSize"
                @current-change="getData()"
                style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>

    <!-- 固件升级 弹出框 -->
    <el-dialog
      :title="titleName"
      :visible.sync="dialogAdd"
      width="60%"
      top="5vh"
      @close="cancelsEdit"
      ref="editref"
    >
      <el-form ref="formUpdate" :model="formUpdate" label-width="130px">
        <el-row :gutter="24">
          <el-col :md="24" :sm="24" :xs="24">
            <el-form-item
              :label="$t('ota.FirmwareUpgradeName')"
              prop="upgradeName"
              :rules="[{ required: true, message: $t('tips.needed') }]"
            >
              <el-input v-model="formUpdate.upgradeName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :md="24" :sm="24" :xs="24">
            <el-form-item
              :label="$t('ota.FirmwareSelect')"
              prop="otaId"
              :rules="[{ required: true, message: $t('tips.needed') }]"
            >
              <el-row :gutter="24">
                <el-col :md="24" :sm="24" :xs="24">
                  <el-select
                    v-model="formUpdate.otaId"
                    :placeholder="$t('desc.select')"
                    filterable
                    style="width: 100%"
                    size="small"
                    @change="otaInfoChanged()"
                  >
                    <el-option
                      v-for="item in otaInfoList"
                      :key="item.id"
                      :value="item.id"
                      :label="item.versionName"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :md="24" :sm="24" :xs="24">
                  <label style="margin-top: 5px; display: block">{{
                    otaInfoDesc
                  }}</label>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <!-- <el-col :md="12" :sm="24" :xs="24">
            <label>{{ otaInfoDesc }}</label>
            <el-form-item>{{ otaInfoDesc }}</el-form-item>    
          </el-col> -->
        </el-row>
        <el-row :gutter="24">
          <el-col :md="24" :sm="24" :xs="24">
            <el-form-item :label="$t('ota.upgradeRemark')">
              <el-input
                v-model="formUpdate.remark"
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="success" @click="onSubmit">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="cancelsEdit">{{ $t("button.cancel") }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 设置设备 弹出框 :model="formMassUpdate"-->
    <el-dialog
      :title="$t('ota.batchUpgrade')"
      :visible.sync="dialogmassUpdate"
      width="80%"
      top="5vh"
      @close="cancels"
    >
      <el-form ref="formMassUpdate" label-width="90px">
        <el-row :gutter="24">
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item :label="$t('title.airCompressorType')">
              <el-cascader
                :options="modeloptions"
                collapse-tags
                clearable
                :props="props"
                v-model="formMassUpdate.deviceModelList"
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <el-form-item :label="$t('ota.gateway')">
              <!-- <el-select
                v-model="formMassUpdate.gsnList"
                multiple
                collapse-tags
                :placeholder="$t('desc.select')"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in getWayoptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select> -->
              <el-input
                style="width: 100%"
                collapse-tags
                v-model="formMassUpdate.gsn"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :md="8" :xs="24" :sm="24">
            <el-form-item :label="$t('ota.controllCcn')">
              <el-input
                style="width: 100%"
                collapse-tags
                v-model="formMassUpdate.ccn"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :xs="24" :sm="24">
            <el-form-item :label="$t('ota.ccnVersion')">
              <el-select
                size="small"
                v-model="formMassUpdate.ccnVersion"
                collapse-tags
                filterable
                :placeholder="$t('desc.select')"
                style="width: 100%"
              >
                <el-option key="" :label="$t('desc.select')" value="">
                </el-option>
                <el-option
                  v-for="item in ccnVersionList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8" :xs="24" :sm="24">
            <el-form-item :label="$t('ota.VersionNumber')">
              <el-input
                style="width: 100%"
                collapse-tags
                v-model="formMassUpdate.firmWareVersion"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="18" :sm="24" :xs="24">
            <el-form-item :label="$t('desc.customer')">
              <el-select
                v-model="formMassUpdate.customerList"
                multiple
                collapse-tags
                :placeholder="$t('desc.select')"
                style="width: 100%"
              >
                <el-option
                  v-for="item in custOption"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="6" :xs="24" :sm="24">
            <el-button
              @click="searchOtaDevices('search')"
              size="primary"
              height="56px"
              style="margin-top: 25px"
              >{{ $t("button.query") }}</el-button
            >
            <el-button
              @click="resetSettingQuery"
              size="small"
              height="56px"
              style="margin-top: 25px"
              >{{ $t("button.reset") }}</el-button
            >
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :md="24" :sm="24" :xs="24">
            <el-form-item :label="$t('ota.airCompressor')">
              <div class="tableDiv">
                <el-table
                  :data="DeviceTable"
                  ref="DeviceTable"
                  stripe
                  v-loading="tableLoading"
                  class="formSTable NoRaidoLabel"
                  :empty-text="$t('desc.noData')"
                  :height="VersionTHeight"
                  style="color: white"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    prop="gsn"
                    width="55"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('desc.airCompressorSN')"
                    prop="dsn"
                    min-width="130px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('desc.gatewaySN')"
                    prop="gsn"
                    min-width="140px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.airCompressorType')"
                    prop="modelName"
                    min-width="300px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.controlsCCN')"
                    prop="ccn"
                    min-width="120px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.ccnVersion')"
                    prop="ccnVersion"
                    min-width="120px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('desc.customerName')"
                    prop="customer"
                    min-width="300px"
                  >
                  </el-table-column>
                </el-table>

                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="pagination2.totalPage"
                  :current-page.sync="pagination2.current"
                  :page-size="pagination2.pageSize"
                  @current-change="searchOtaDevices('')"
                  style="text-align: center; margin-top: 10px"
                ></el-pagination>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="success" @click="otaUpdate">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="cancels">{{ $t("button.cancel") }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 升级结果查看 弹出框 -->
    <el-dialog
      :title="$t('ota.upgradeResult')"
      :visible.sync="dialogUpdateResult"
      width="90%"
      top="5vh"
      @close="cancelResult"
    >
      <div class="DeviceDiv AlarmInfo">
        <el-form ref="formUpgradeResult" label-width="70px">
          <el-row
            :gutter="24"
            class="info"
            style="
              padding-top: 0;
              border-top: 0;
              margin-left: 0px !important;
              margin-right: 0px !important;
            "
          >
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <span>{{ $t("ota.FirmwareUpgrade") }}：</span
              >{{ ResultForm.otaUpgradeName }}
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <span>{{ $t("ota.FirmwareName") }}：</span
              >{{ ResultForm.versionName }}
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <span>{{ $t("ota.deviceType") }}：</span
              >{{ $t("ota." + ResultForm.deviceType) }}
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <span>{{ $t("ota.VersionNumber") }}：</span
              >{{ ResultForm.versionNo }}
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <span>{{ $t("desc.describe") }}：</span
              >{{ ResultForm.upgradeDesc }}
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <span>{{ $t("title.brand") }}：</span>{{ ResultForm.brandCode }}
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <span>{{ $t("ota.upgradeResult") }}：</span>

              <div style="position: fixed; right: 7%">
                <span>{{ $t("ota.TotalUpgrades") }} </span>
                <span
                  style="color: white; margin-right: 10px; line-height: 18px"
                  >{{ ResultForm.sumCount }}</span
                >

                <span>{{ $t("ota.NumberOfSuccesses") }} </span>
                <span
                  style="color: green; margin-right: 10px; line-height: 18px"
                  >{{ ResultForm.successCount }}</span
                >
                <span>{{ $t("ota.NumberOfFailures") }} </span>
                <span
                  style="color: red; margin-right: 10px; line-height: 18px"
                  >{{ ResultForm.failCount }}</span
                >
              </div>
              <div class="divide" style="margin-bottom: 0"></div>
            </el-col>
            <!-- <el-col :md="6" :xs="24" :sm="24">
              <el-form-item
                :label="$t('ota.controllCcn')"
                style="margin-top: 0px"
              >
                <el-input
                  style="width: 100%"
                  v-model="searchCcn"
                  size="small"
                  height="28px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="6" :xs="24" :sm="24">
              <el-form-item
                :label="$t('title.ccnVersion')"
                style="margin-top: 0px"
              >
                <el-select
                  size="small"
                  v-model="searchCcnVersion"
                  filterable
                  :placeholder="$t('desc.select')"
                  style="width: 100%"
                  height="28px"
                >
                  <el-option key="" :label="$t('desc.select')" value="">
                  </el-option>
                  <el-option
                    v-for="item in ccnVersionList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->

            <el-col :md="5" :xs="24" :sm="24">
              <el-form-item
                :label="$t('ota.upgradeStatus')"
                style="margin-top: 0px"
              >
                <el-select
                  size="small"
                  v-model="searchUpgradeStatus"
                  :placeholder="$t('desc.select')"
                  style="width: 100%"
                  height="28px"
                >
                  <el-option key="99" :label="$t('desc.select')" value="99">
                  </el-option>
                  <el-option key="0" label="未升级" value="0"> </el-option>
                  <el-option key="1" label="已下发" value="1"> </el-option>
                  <el-option key="2" label="升级中" value="2"> </el-option>
                  <el-option key="3" label="成功" value="3"> </el-option>
                  <el-option key="-1" label="失败" value="-1"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8" :xs="24" :sm="24">
              <el-form-item :label="$t('ota.gateway')" style="margin-top: 0px">
                <el-select
                  v-model="searchRetGsnList"
                  multiple
                  collapse-tags
                  :placeholder="$t('desc.select')"
                  style="width: 100%"
                  filterable
                >
                  <el-option
                    v-for="item in getWayoptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :md="5" :xs="24" :sm="12">
              <el-form-item
                :label="$t('acronym.gatewaystatus')"
                style="margin-top: 0px"
              >
                <el-select
                  size="small"
                  v-model="searchBeatStatus"
                  :placeholder="$t('desc.select')"
                >
                  <el-option
                    value="99"
                    :label="$t('ota.selectAll')"
                  ></el-option>
                  <el-option :label="$t('ota.online')" value="1"></el-option>
                  <el-option :label="$t('ota.warning')" value="2"></el-option>
                  <el-option :label="$t('ota.offline')" value="-1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="6" :xs="24" :sm="24">
              <el-button
                @click="getOtaUpgradeDetail(ResultForm.otaUpgradeId, 'result')"
                size="small"
                style="color: white !important; height: 28px; padding-top: 6px"
                >{{ $t("button.query") }}</el-button
              >
              <el-button
                @click="resetResultQuery"
                size="small"
                style="height: 28px; padding-top: 6px"
                >{{ $t("button.reset") }}</el-button
              >

              <el-button
                size="small"
                @click="
                  exportOtaUpgradeDetail(
                    ResultForm.otaUpgradeId,
                    ResultForm.otaUpgradeName
                  )
                "
                style="height: 28px; padding-top: 6px"
                >{{ $t("button.exportUpgradeResult") }}</el-button
              >
            </el-col>

            <el-col>
              <div class="tableDiv">
                <el-table
                  :data="ResultForm.otaDeviceList"
                  stripe
                  v-loading="tableLoading"
                  :empty-text="$t('desc.noData')"
                >
                  <el-table-column
                    type="index"
                    :label="$t('title.serialNumber')"
                    width="60"
                    fixed="left"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('desc.airCompressorSN')"
                    prop="dsn"
                    min-width="130px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('desc.gatewaySN')"
                    prop="gsn"
                    min-width="130px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.airCompressorType')"
                    prop="deviceModel"
                    min-width="180px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.controlsCCN')"
                    prop="ccn"
                    min-width="130px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.ccnVersion')"
                    prop="ccnVersion"
                    min-width="80px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('desc.customerName')"
                    prop="customerName"
                    min-width="150px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.upgradeStatus')"
                    prop="upgradeStatus"
                    min-width="100px"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        type="success"
                        v-if="scope.row.upgradeStatus == '3'"
                        >{{ $t("ota.upgradeSucceeded") }}</el-tag
                      >
                      <el-tag
                        type="danger"
                        v-if="scope.row.upgradeStatus == '-1'"
                        >{{ $t("ota.upgradeFailed") }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-if="scope.row.upgradeStatus == '2'"
                        >{{ $t("ota.upgrading") }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-if="scope.row.upgradeStatus == '1'"
                        >{{ $t("ota.issued") }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-if="scope.row.upgradeStatus == '0'"
                        >{{ $t("ota.notUpgraded") }}</el-tag
                      >
                    </template>
                  </el-table-column>

                  <el-table-column
                    :label="$t('ota.flowStatus')"
                    prop="flowStatus"
                    min-width="150px"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        type="success"
                        v-if="scope.row.flowStatus == '6'"
                        >{{ $t("ota.手动升级成功") }}</el-tag
                      >
                      <el-tag
                        type="success"
                        v-if="scope.row.flowStatus == '5'"
                        >{{ $t("ota.已安装升级包") }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-if="scope.row.flowStatus == '4'"
                        >{{ $t("ota.已接收安装命令") }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-if="scope.row.flowStatus == '3'"
                        >{{ $t("ota.已下发安装命令") }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-if="scope.row.flowStatus == '2'"
                        >{{ $t("ota.已下载升级包") }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-if="scope.row.flowStatus == '1'"
                        >{{ $t("ota.已下发升级包") }}</el-tag
                      >
                      <el-tag
                        type="warning"
                        v-if="scope.row.flowStatus == '0'"
                        >{{ $t("ota.未升级") }}</el-tag
                      >
                      <el-tag
                        type="danger"
                        v-if="scope.row.flowStatus == '-1'"
                        >{{ $t("ota.下载失败") }}</el-tag
                      >
                      <el-tag
                        type="danger"
                        v-if="scope.row.flowStatus == '-2'"
                        >{{ $t("ota.接收命令失败") }}</el-tag
                      >
                      <el-tag
                        type="danger"
                        v-if="scope.row.flowStatus == '-3'"
                        >{{ $t("ota.安装失败") }}</el-tag
                      >
                      <el-tag
                        type="danger"
                        v-if="scope.row.flowStatus == '-4'"
                        >{{ $t("ota.手动升级失败") }}</el-tag
                      >
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="beatStatusName"
                    :label="$t('title.gatewaystatus')"
                    width="80px"
                  >
                    <template slot-scope="scope">
                      {{ $t("gatewayState." + scope.row.beatStatusName) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.remark')"
                    prop="remark"
                    min-width="120px"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.upgradeScheduledTime')"
                    prop="scheduledTime"
                    min-width="150px"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.isScheduled == false ||
                        scope.row.scheduledTime == null
                          ? ""
                          : scope.row.scheduledTime.replace("T", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.upgradePushFileTime')"
                    prop="pushFileTime"
                    min-width="150px"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.pushFileTime == null
                          ? ""
                          : scope.row.pushFileTime.replace("T", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.upgradeDownLoadFileTime')"
                    prop="receiveFileTime"
                    min-width="150px"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.receiveFileTime == null
                          ? ""
                          : scope.row.receiveFileTime.replace("T", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.upgradePushInstallTime')"
                    prop="pushInstallTime"
                    min-width="150px"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.pushInstallTime == null
                          ? ""
                          : scope.row.pushInstallTime.replace("T", " ")
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('ota.completionTime')"
                    prop="upgradeTime"
                    min-width="150px"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.upgradeTime != null
                          ? scope.row.upgradeTime.replace("T", " ")
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('title.operate')"
                    min-width="120px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <template>
                        <el-popconfirm
                          placement="top"
                          v-if="
                            ResultForm.deviceType == 'controller' &&
                            ResultForm.deviceBrand == 'HC' &&
                            !scope.row.isScheduled &&
                            scope.row.upgradeStatus != 3 &&
                            (scope.row.flowStatus == 0 ||
                              scope.row.flowStatus == -1 ||
                              scope.row.flowStatus == -3)
                          "
                          :confirmButtonText="$t('button.confirm')"
                          :cancelButtonText="$t('button.cancel')"
                          icon="el-icon-info"
                          iconColor="red"
                          :title="$t('ota.confirmPushFile')"
                          @confirm="
                            pushJobFile(scope.row.otaUpgradeId, scope.row.gsn)
                          "
                          :ref="`popoverPushFile-${scope.$index}`"
                        >
                          <el-button
                            type="warning"
                            icon="el-icon-s-promotion"
                            circle
                            :title="$t('ota.upgradePushFileTitle')"
                            size="mini"
                            slot="reference"
                          ></el-button>
                        </el-popconfirm>
                      </template>

                      <template>
                        <el-popconfirm
                          placement="top"
                          :confirmButtonText="$t('button.confirm')"
                          :cancelButtonText="$t('button.cancel')"
                          icon="el-icon-info"
                          iconColor="red"
                          :title="$t('ota.confirmPushUpgradeInstall')"
                          @confirm="
                            pushInstallCommand(
                              scope.row.otaUpgradeId,
                              scope.row.gsn
                            )
                          "
                          :ref="`popoverPushInstall-${scope.$index}`"
                          v-if="
                            !scope.row.isScheduled &&
                            scope.row.upgradeStatus != 3 &&
                            (scope.row.flowStatus == 1 ||
                              scope.row.flowStatus == 2 ||
                              scope.row.flowStatus == -2 ||
                              scope.row.flowStatus == -3)
                          "
                        >
                          <el-button
                            type="warning"
                            icon="el-icon-s-tools"
                            circle
                            :title="$t('ota.upgradePushInstallTitle')"
                            size="mini"
                            slot="reference"
                          ></el-button>
                        </el-popconfirm>
                      </template>

                      <template>
                        <el-button
                          v-if="
                            ResultForm.deviceType == 'controller' &&
                            ResultForm.deviceBrand == 'HC' &&
                            scope.row.upgradeStatus == 1
                          "
                          type="warning"
                          icon="el-icon-timer"
                          circle
                          title="定时升级"
                          size="mini"
                          @click="TimeUpgrade2(scope.row)"
                        ></el-button>
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <!-- 定时升级 弹出框 -->
    <el-dialog
      :title="$t('ota.RegularUpgrade')"
      :visible.sync="dialogTimeUpgrade"
      width="80%"
      top="5vh"
      @close="cancelTimer"
    >
      <div class="DeviceDiv AlarmInfo" style="min-height: auto; height: auto">
        <el-row
          :gutter="24"
          class="info"
          style="
            padding-top: 0;
            border-top: 0;
            margin-left: 0px !important;
            margin-right: 0px !important;
          "
        >
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <span>{{ $t("ota.FirmwareName") }}：</span
            >{{ UpdateForm.versionName }}
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <span>{{ $t("ota.deviceType") }}：</span
            >{{ $t("ota." + UpdateForm.deviceType) }}
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <span>{{ $t("ota.VersionNumber") }}：</span
            >{{ UpdateForm.versionNo }}
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <span>{{ $t("desc.describe") }}：</span>{{ UpdateForm.upgradeDesc }}
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8">
            <span>{{ $t("title.brand") }}：</span>{{ UpdateForm.brandCode }}
          </el-col>
        </el-row>
      </div>
      <div class="tableDiv">
        <el-form ref="UpdateForm" :model="UpdateForm" label-width="130px">
          <el-form-item label="定时升级" style="margin-top: 0px">
            <el-date-picker
              v-model="UpdateForm.scheduledTime"
              type="datetime"
              :placeholder="$t('tips.selectTime')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="setTimingUpgrade">{{
              $t("button.confirm")
            }}</el-button>
            <el-button @click="cancelTimer">{{
              $t("button.cancel")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  authOperationCheck,
  getBrandInfos,
  getDeviecModelTree,
  getGatewayOption,
  getAllCustomer,
  getOtaDevices,
  getOtaUpgradeDetail,
  createOtaUpgrade,
  updateOtaUpgrade,
  deleteOtaUpgrade,
  getOtaUpgradeList,
  saveUpgradeDevices,
  pushJobFile,
  pushInstallCommand,
  getOtaInfoList,
  setTimingUpgrade,
  getCcnVersionList,
  exportExcelNew,
} from "../../api/api";
import { MessageBox } from "element-ui";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "index",
  data() {
    return {
      submitBtn: true,
      checkRes: false,
      titleName: "",
      loading: false,
      autoUpload: false,
      dialogAdd: false,
      dialogmassUpdate: false,
      dialogUpdateResult: false,
      props: { multiple: true },
      VersionTHeight: 500,
      formselect: {
        name: "",
        type: "",
      },
      searchCcn: "",
      searchCcnVersion: "",
      searchUpgradeStatus: "99",
      ccnVersionList: [],
      tableData1: [],
      brandInfo: {},
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      pagination2: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      otaInfoDesc: "",
      formUpdate: {
        id: 0,
        otaId: "",
        upgradeName: "",
        // deviceType: "",
        // versionNo: "",
        // describeContent: "",
        // brandCode: "",
        // upgradeDesc: "",
        // deviceBrand: "",
        // engineerVersionNo: "",
      },
      postData: {},
      fileList: [],
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasOtaUpgradeAuth: false,
      formMassUpdate: {},
      modeloptions: [],
      getWayoptions: [],
      custOption: [],
      otaDeviceList: [],
      otaInfoList: [],
      DeviceTable: [],
      setGsnList: [],
      resultGsnList: [],
      setOtaGsnList: [],
      searchRetGsnList: [],
      searchBeatStatus: "99",
      otaUpgradeId: "",
      ResultForm: {
        table: [
          { customer: "e214发货不额外吧", state: "success" },
          { state: "failure" },
          { state: "load" },
        ],
      },
      dialogTimeUpgrade: false,
      tableLoading: false,
      UpdateForm: {},
      gsnStateList: {
        0: "未连接",
        1: "在线",
        2: "警告",
        "-1": "离线",
      },
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  created: function () {
    this.authOperation("Ota");
  },
  mounted() {
    this.getBrandInfos();
    this.getOtaInfoList();
    this.getData();
    this.getDeviecModelTree();
    this.getGatewayOption();
    this.getCustOption();
    this.getCcnVersionList();
  },
  methods: {
    getCcnVersionList() {
      let that = this;
      getCcnVersionList().then((res) => {
        let data = res.result;
        that.ccnVersionList = data;
      });
    },
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasOtaUpgradeAuth = res.hasOtaUpgradeAuth;
    },
    setTimingUpgrade() {
      var that = this;
      var data = {
        otaUpgradeId: this.UpdateForm.otaUpgradeId,
        timingDate: this.UpdateForm.scheduledTime,
        gsn: this.UpdateForm.gsn,
      };
      setTimingUpgrade(data).then((res) => {
        if (res.result) {
          that.dialogTimeUpgrade = false;
          that.getData();
          that.$message.success("设置定时升级成功");
        } else {
          that.$message.error("设置定时升级失败");
        }
      });
    },
    otaInfoChanged() {
      var info = {};
      var otaId = this.formUpdate.otaId;
      this.otaInfoList.forEach(function (o) {
        if (o.id == otaId) info = o;
      });
      var desc =
        "版本号：" +
        info.versionNo +
        ", " +
        "固件类型：" +
        info.deviceType +
        ", " +
        "设备厂商：" +
        info.deviceBrand;
      this.otaInfoDesc = desc;
    },
    async massUpdate(row) {
      var that = this;
      this.dialogmassUpdate = true;
      this.otaUpgradeId = row.id;
      that.resultGsnList = [];
      await this.getOtaUpgradeDetail(row.id, "setting");
      await this.getOtaDevices("search");

      that.DeviceTable.forEach((d) => {
        that.$refs.DeviceTable.toggleRowSelection(d, false);
        that.setGsnList.forEach((g) => {
          if (g == d.gsn) {
            d.selected = 1;
            that.$refs.DeviceTable.toggleRowSelection(d, true);
          }
        });
      });
      this.VersionTHeight = window.innerHeight * 0.9 - 370 - 45 + "px";
    },
    async searchOtaDevices(type) {
      let that = this;
      // let postData = that.formMassUpdate;
      // postData.language = that.activeLang;
      let res = await this.getOtaDevices(type);

      //console.log("setGsnList=" + JSON.stringify(this.setGsnList));
      that.DeviceTable.forEach((d) => {
        that.$refs.DeviceTable.toggleRowSelection(d, false);
        that.setGsnList.forEach((g) => {
          if (g == d.gsn) {
            d.selected = 1;
            that.$refs.DeviceTable.toggleRowSelection(d, true);
          }
        });
      });
    },
    async getOtaDevices(type) {
      let that = this;
      this.loading = true;
      if (type == "search") {
        this.pagination2.current = 1;
      }
      let skipcount =
        (this.pagination2.current - 1) * this.pagination2.pageSize;

      that.DeviceTable = [];
      let postData = that.formMassUpdate;
      postData.language = that.activeLang;
      postData.skipCount = skipcount;
      postData.maxResultCount = this.pagination2.pageSize;
      let res = await getOtaDevices(postData);
      this.loading = false;
      this.pagination2.totalPage = res.result.totalCount;
      this.DeviceTable = res.result.items;
    },

    async getOtaUpgradeDetail(otaUpgradeId, type) {
      let that = this;
      that.resultGsnList = [];
      let postData = {
        otaUpgradeId: otaUpgradeId,
        language: that.activeLang,
        ccn: that.searchCcn,
        upgradeStatus: that.searchUpgradeStatus,
        beatStatus: that.searchBeatStatus,
        ccnVersion: that.searchCcnVersion,
        gsnList: that.searchRetGsnList,
      };
      let res = await getOtaUpgradeDetail(postData);
      if (
        res.result != null &&
        res.result.otaDeviceList != null &&
        res.result.otaDeviceList.length > 0
      ) {
        res.result.otaDeviceList.forEach(function (o) {
          o.beatStatusName = that.gsnStateList[o.beatStatus];
        });
      }
      if (type == "result") {
        that.ResultForm = res.result;
      } else if (type == "setting") {
        that.resultGsnList = res.result.otaDeviceList.map((x) => x.gsn);
        that.setGsnList = res.result.otaDeviceList.map((x) => x.gsn);
      }
    },

    async exportOtaUpgradeDetail(otaUpgradeId, otaUpgradeName) {
      this.loading = true;
      let that = this;
      var exportData = [
        [
          that.$t('desc.airCompressorSN'),
          that.$t('desc.gatewaySN'),
          that.$t('title.airCompressorType'),
          that.$t('title.controlsCCN'),
          that.$t('ota.ccnVersion'),
          that.$t('ota.upgradeStatus'),
          that.$t('ota.flowStatus'),
          that.$t('title.gatewaystatus'),
          that.$t('ota.upgradeScheduledTime'),
          that.$t('ota.upgradePushFileTime'),
          that.$t('ota.upgradeDownLoadFileTime'),
          that.$t('ota.upgradePushInstallTime'),
          that.$t('ota.completionTime'),
        ],
      ];
      var fileName = that.$t("exportContent.OTA升级任务") + " - " + otaUpgradeName + " - " + that.$t("exportContent.升级结果导出") + ".xlsx";

      let postData = {
        otaUpgradeId: otaUpgradeId,
        language: that.activeLang,
        ccn: that.searchCcn,
        upgradeStatus: that.searchUpgradeStatus,
        beatStatus: that.searchBeatStatus,
        ccnVersion: that.searchCcnVersion,
        gsnList: that.searchRetGsnList,
      };
      let res = await getOtaUpgradeDetail(postData);
      var data = res.result.otaDeviceList;
      //导入数据里有null会导致文件损坏
      const dataSource = data.map((item) => {
        Object.keys(item).forEach((key) => {
          // 后端传null node写入会有问题
          if (item[key] === null) {
            item[key] = "";
          }

          if (Array.isArray(item[key])) {
            item[key] = item[key].join(",");
          }
        });
        return item;
      });
      dataSource.forEach((item) => {
        var beatStatusName = that.gsnStateList[item.beatStatus];
        var upgradeStatusDesc = "";
        var flowStatusDesc = "";
        if (item.upgradeStatus == "3")
          upgradeStatusDesc = that.$t("ota.upgradeCompleted");
        if (item.upgradeStatus == "-1")
          upgradeStatusDesc = that.$t("ota.upgradeFailed");
        if (item.upgradeStatus == "2")
          upgradeStatusDesc = that.$t("ota.upgrading");
        if (item.upgradeStatus == "1")
          upgradeStatusDesc = that.$t("ota.issued");
        if (item.upgradeStatus == "0")
          upgradeStatusDesc = that.$t("ota.notUpgraded");

        if (item.flowStatus == "6")
          flowStatusDesc = that.$t("ota.手动升级成功");
        if (item.flowStatus == "5")
          flowStatusDesc = that.$t("ota.已安装升级包");
        if (item.flowStatus == "4")
          flowStatusDesc = that.$t("ota.已接收安装命令");
        if (item.flowStatus == "3")
          flowStatusDesc = that.$t("ota.已下发安装命令");
        if (item.flowStatus == "2")
          flowStatusDesc = that.$t("ota.已下载升级包");
        if (item.flowStatus == "1")
          flowStatusDesc = that.$t("ota.已下发升级包");
        if (item.flowStatus == "0") flowStatusDesc = that.$t("ota.未升级");
        if (item.flowStatus == "-1") flowStatusDesc = that.$t("ota.下载失败");
        if (item.flowStatus == "-2")
          flowStatusDesc = that.$t("ota.接收命令失败");
        if (item.flowStatus == "-3") flowStatusDesc = that.$t("ota.安装失败");
        if (item.flowStatus == "-4")
          flowStatusDesc = that.$t("ota.手动升级失败");

        let rowData = [];
        rowData = [
          item.dsn,
          item.gsn,
          item.deviceModel,
          item.ccn,
          item.ccnVersion,
          upgradeStatusDesc,
          flowStatusDesc,
          that.$t("gatewayState." + beatStatusName),
          item.scheduledTime != null
            ? item.scheduledTime.replace("T", " ").substr(0, 16)
            : "",
          item.pushFileTime != null
            ? item.pushFileTime.replace("T", " ").substr(0, 16)
            : "",
          item.receiveFileTime != null
            ? item.receiveFileTime.replace("T", " ").substr(0, 16)
            : "",
          item.pushInstallTime != null
            ? item.pushInstallTime.replace("T", " ").substr(0, 16)
            : "",
          item.receiveInstallTime != null
            ? item.receiveInstallTime.replace("T", " ").substr(0, 16)
            : "",
        ];
        exportData.push(rowData);
      });
      exportExcelNew(exportData, fileName);
      this.loading = false;
    },

    async getOtaInfoList() {
      let that = this;
      let res = await getOtaInfoList();
      that.otaInfoList = res.result;
    },
    async getDeviecModelTree() {
      let that = this;
      let res = await getDeviecModelTree(that.activeLang);
      this.modeloptions = res.result;
    },
    async getGatewayOption() {
      let that = this;
      let res = await getGatewayOption();
      this.getWayoptions = res.result;
    },
    async getCustOption() {
      let that = this;
      let res = await getAllCustomer();
      let data = res.result;
      for (let index = 0; index < data.length; index++) {
        that.custOption = data;
        that.custOption[index].customerName =
          data[index].customerCode +
          "_" +
          data[index].customerName +
          "_" +
          data[index].companyType +
          "_" +
          data[index].manageCpName;
      }
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    getData() {
      this.loading = true;
      var data = {
        upgradeName: this.formselect.upgradeName,
        //type: this.formselect.type,
      };
      data.SkipCount = (this.pagination.current - 1) * this.pagination.pageSize;
      data.MaxResultCount = this.pagination.pageSize;
      getOtaUpgradeList(data).then((res) => {
        if (res.success) {
          this.pagination.totalPage = res.result.totalCount;
          this.loading = false;
          this.tableData1 = res.result.items;
        }
      });
    },
    //上传路径获取
    getUrl() {
      let imgactionurl = "";
      if (process.env.NODE_ENV === "development") {
        imgactionurl =
          this.$baseConfig.VUE_APP_LocalRootUrl +
          "api/services/app/Ota/UploadOtaFile"; //这是调用测试数据接口
      } else {
        imgactionurl =
          this.$baseConfig.VUE_APP_PublishRootUrl +
          "api/services/app/Ota/UploadOtaFile"; //线上
      }
      return imgactionurl;
    },
    handleAccredit(index, row) {},
    handleDelete(index, row) {},

    onSubmit() {
      let data = this.formUpdate;
      let formData = new FormData();
      for (let property in data) {
        formData.append(property, data[property]);
      }
      this.fileList.forEach((element) => {
        formData.append("fileList", element.raw);
      });
      this.$refs["formUpdate"].validate((valid) => {
        if (valid) {
          if (this.dialogType == "add") {
            delete data.id;
            createOtaUpgrade(formData)
              .then((res) => {
                if (res.success) {
                  this.$message.success("success");
                  this.dialogAdd = false;
                  this.fileList = [];
                  this.getData();
                } else {
                  this.$message.error(res.error.message);
                }
              })
              .catch((err) => {
                this.$message.error(err.error.message);
              });
          } else {
            updateOtaUpgrade(formData)
              .then((res) => {
                if (res.success) {
                  this.$message.success("success");
                  this.dialogAdd = false;
                  this.fileList = [];
                  this.getData();
                } else {
                  this.$message.error(res.error.message);
                }
              })
              .catch((err) => {
                this.$message.error(err.error.message);
              });
          }
        }
      });
    },

    //上传前校验
    handleChange(file, fileList) {
      if (file.status === "ready") {
        this.$refs["formUpdate"].validate((valid) => {
          if (valid) {
            this.fileList = fileList;
          } else {
            file = "";
            this.fileList = [];
          }
        });
      }
    },

    handleExceed(files, fileList) {
      this.$message.warning(this.$t("ota.tipsMessage1"));
    },

    beforeRemove(file, fileList) {
      if (this.checkRes) {
        return this.$confirm(
          this.$t("ota.cofirmDelete") + "  '" + `${file.name}` + "'?",
          {
            confirmButtonText: this.$t("desc.yes"),
            cancelButtonText: this.$t("desc.no"),
          }
        ).then((action) => {
          this.submitBtn = true;
          // console.log(this.formUpdate.id)
        });
      }
    },

    handlePreview() {},
    submitUpload() {
      this.postData.versionNo = this.formUpdate.versionNo;
      this.$refs.upload.submit();
    },

    handleAvatarSuccess(res, file) {},
    showAddDialog(visible) {
      this.dialogAdd = visible;
      this.dialogType = "add";
      this.titleName = this.$t("ota.createUpgrade");
    },

    edit(row) {
      this.dialogAdd = true;
      this.dialogType = "edit";
      this.titleName = this.$t("ota.editUpgrade");
      this.formUpdate = JSON.parse(JSON.stringify(row));
      this.submitBtn = false;

      var info = {};
      var otaId = this.formUpdate.otaId;
      this.otaInfoList.forEach(function (o) {
        if (o.id == otaId) info = o;
      });
      var desc =
        "版本号：" +
        info.versionNo +
        ", " +
        "固件类型：" +
        info.deviceType +
        ", " +
        "设备厂商：" +
        info.deviceBrand;
      this.otaInfoDesc = desc;
    },

    resetKeyword() {
      this.formselect = {
        name: "",
        type: "",
      };
    },
    cancelsEdit() {
      this.dialogAdd = false;
      this.fileList = [];
      this.formUpdate = {};
      this.$refs["formUpdate"].resetFields();
    },
    handleDelTest(row) {
      this.id = row.id;
      this.$confirm("是否确认要删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$message({
            type: "success",
            message: "删除成功",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //删除
    delInfo(e) {
      deleteOtaUpgrade(e).then((res) => {
        if (res.success) {
          this.$message.success(this.$t("tips.deleteSuccess"));
          this.getData();
        } else {
          this.$message.error(error.error.message);
        }
      });
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
    },

    //分页数据
    handleCurrentChange2(val) {
      this.pagination2.current = val;
    },
    handleSizeChange2(val) {
      this.pagination2.pageSize = val;
    },
    handleSelectionChange(val) {
      var that = this;
      val.map((x) => {
        var isExist = 0;
        that.setGsnList.forEach((s) => {
          if (s == x.gsn) {
            isExist = 1;
          }
        });
        if (isExist == 0) {
          that.setGsnList.push(x.gsn);
        }
      });
    },
    // showUpdateDialog(visible) {
    //   this.dialogUpdate = visible;
    //   this.VersionTHeight = window.innerHeight * 0.9 - 230 + "px";
    // },
    async getBrandInfos() {
      let that = this;
      let res = await getBrandInfos();
      let brandCode = localStorage.getItem("user_brand")
        ? localStorage.getItem("user_brand")
        : "IR";
      that.brandInfo = res.result.find((x) => x.brandCode == brandCode);
    },

    cancels() {
      let that = this;
      that.dialogmassUpdate = false;
      //this.$refs[this.refForm].resetFields();
    },
    async UpdateResult(row) {
      this.dialogUpdateResult = true;
      await this.getOtaUpgradeDetail(row.id, "result");
      //this.VersionTHeight = window.innerHeight * 0.9 - 330 + "px";
    },
    TimeUpgrade(row) {
      this.dialogTimeUpgrade = true;
      this.otaUpgradeId = row.id;
      this.UpdateForm = row;
    },
    TimeUpgrade2(row) {
      this.dialogTimeUpgrade = true;
      this.UpdateForm = {
        otaUpgradeId: this.ResultForm.otaUpgradeId,
        versionName: this.ResultForm.versionName,
        deviceType: this.ResultForm.deviceType,
        versionNo: this.ResultForm.versionNo,
        upgradeDesc: this.ResultForm.upgradeDesc,
        brandCode: this.ResultForm.brandCode,
        deviceType: this.ResultForm.deviceType,
        gsn: row.gsn,
      };
    },
    cancelResult() {
      let that = this;
      that.dialogUpdateResult = false;
      //this.$refs[this.ResultForm].resetFields();
    },
    async otaUpdate() {
      let that = this;
      let data = {
        OtaUpgradeId: this.otaUpgradeId,
        GsnList: this.setGsnList,
      };
      try {
        let res = await saveUpgradeDevices(data);

        if (res.result === true) {
          that.$message.success(this.$t("ota.upgradeDeviceSaveSuccess"));
          that.cancels();
        } else {
          that.$message.warning(res.result.description);
        }
      } catch (error) {
        this.$message.error(error.error.message);
      }
    },

    async pushJobFile(upgradeId, gsn) {
      let that = this;
      let gsnList = [];
      if (gsn != undefined && gsn != "") {
        gsnList.push(gsn);
      }
      let data = {
        OtaUpgradeId: upgradeId,
        GsnList: gsnList,
      };
      try {
        let res = await pushJobFile(data);
        if (res.result.isSuccess === true) {
          that.$message.success(this.$t("ota.upgradeFileSending"));
          that.cancels();
          that.getData();
          that.getOtaUpgradeDetail(upgradeId, "result");
        } else {
          that.$message.warning(res.result.description);
        }
      } catch (error) {
        console.log(error);
        this.$message.error(error.error.message);
      }
    },

    async pushInstallCommand(upgradeId, gsn) {
      let that = this;
      let gsnList = [];
      if (gsn != undefined && gsn != "") {
        gsnList.push(gsn);
      }
      let data = {
        OtaUpgradeId: upgradeId,
        GsnList: gsnList,
      };
      try {
        let res = await pushInstallCommand(data);
        if (res.result.isSuccess === true) {
          that.$message.success(this.$t("ota.upgradeInstallSending"));
          that.cancels();
          that.getData();
          that.getOtaUpgradeDetail(upgradeId, "result");
        } else {
          that.$message.warning(res.result.description);
        }
      } catch (error) {
        this.$message.error(error.error.message);
      }
    },
    resetSettingQuery() {
      this.formMassUpdate = {};
    },
    resetResultQuery() {
      this.searchCcn = "";
      this.searchUpgradeStatus = "99";
      this.searchBeatStatus = "99";
      this.searchCcnVersion = "";
      this.searchRetGsnList = [];
    },
    cancelTimer() {
      this.dialogTimeUpgrade = false;
    },
  },
};
</script>

 